// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__vzHa0","total":"Cart_total__2eGro","actions":"Cart_actions__1WjU2","button--alt":"Cart_button--alt__2HE6d","button":"Cart_button__UFFpv"};